<template>
  <div class="bg-secondary-500 m-3 p-4 text-white text-center cursor-pointer text-[12px] phone:text-sm sm:p-5 md:p-8 md:w-80 md:h-[120px] transition-all rounded-2xl hover:bg-primary-500 hover:border-secondary-500 hover:border-r-8">
    <slot/>
  </div>
</template>